import { render, staticRenderFns } from "./AdministrationDepthHeightDatumManage.vue?vue&type=template&id=2575d380&scoped=true"
import script from "./AdministrationDepthHeightDatumManage.vue?vue&type=script&lang=js"
export * from "./AdministrationDepthHeightDatumManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2575d380",
  null
  
)

export default component.exports